<template>
  <div>
    <!-- <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=360696207456838&amp;ev=PageView"/>

    <img height="1" width="1" style="display:none" :src="`https://www.facebook.com/tr?id=360696207456838&amp;ev=Purchase&amp;cd[currency]=INR&amp;cd[value]=` + c.total" v-if="this.$router.currentRoute.path == '/checkout'"/>

    <img height="1" width="1" style="display:none" :src="`https://www.facebook.com/tr?id=360696207456838&amp;ev=AddToCart&amp;cd[currency]=INR&amp;cd[value]=` + c.total" v-if="this.$router.currentRoute.path == '/cart'"/> -->
    <div class="headingregular op_5"> Billing Details</div>
    <div class="sidebox">
      <ul>
        <li>
          <span class="float-none">
            Cart Total
            <span v-if="showPriceExclusiveOnCart && isSelectedCountryIndia" class="float-none mrp-text">
              ({{ showPriceExclusiveOnCart.description }})
            </span>
            <span v-if="showMrpOnCartGlobal && !isSelectedCountryIndia" class="float-none mrp-text">
              ({{ showMrpOnCartGlobal.description }})
            </span>
          </span>
          <!-- update required before switched to inclusive model -->
          <span v-if="bannerPlaceHolderForNewGstCartUi" class="fbold">
            {{ currencySymbol }} {{((c.sub_total+c.total_savings) + c.gst_total).toFixed(2)}}
          </span>
          <span v-else class="fbold">
            {{ currencySymbol }} {{(c.sub_total+c.total_savings + c.used_tss_points).toFixed(2)}}
          </span>
        </li>
        <li class="fblue" v-if="c.coupon_discount && bannerPlaceHolderForCouponDiscount">
          Coupon Savings
          <span class="fbold fblue">
            - {{ currencySymbol }} {{ c.coupon_discount.toFixed(2) }}
            </span>
        </li>
        <li class="fblue" v-if="getBillingDiscount && getBillingDiscount > 0">
          {{isExclusive ? ((memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings') : 'Discount'}}
          <span class="fbold">
          - {{ currencySymbol }} {{ getBillingDiscount.toFixed(2)}}
          </span>
        </li>
        <li class="fblue" v-if="c.used_tss_points">
          TSS Points Applied
          <span class="fbold">
            - {{ currencySymbol }} {{ c.used_tss_points.toFixed(2) }}
          </span>
        </li>
        <li v-if="!bannerPlaceHolderForNewGstCartUi">
          {{ isSelectedCountryIndia ? 'GST' : 'TAX' }}
          <span v-if="c.gst_total">
              {{ currencySymbol }} {{(c.gst_total).toFixed(2)}}
            </span>
          <span v-else>
              {{ currencySymbol }} 0
            </span>
        </li>
        <li v-if="payMethod && payMethod === 'cod' && c.cod_charges">
          COD
          <span>
            {{ currencySymbol }} {{c.cod_charges.toFixed(2)}}
          </span>
        </li>
        <li v-if="c.hl_charges > 0">
          Express Delivery
          <span class="fblue">
            {{ (c.hl_charges === 0) ? (currencySymbol + ' 0') : (currencySymbol + ' ' + (c.hl_charges).toFixed(2)) }}
            </span>
        </li>
        <li>
          Shipping Charges
          <span class="ml-2 revamp" v-if="c.shipping_charges === 0 && c.actual_shipping_charges > 0">
              {{ (c.actual_shipping_charges === 0) ? (currencySymbol + ' 0') : (currencySymbol + ' ' + (c.actual_shipping_charges).toFixed(2)) }}
          </span>
          <span class="fblue">
              {{ (c.shipping_charges === 0) ? 'Free' : (currencySymbol + ' ' + (c.shipping_charges).toFixed(2)) }}
          </span>
        </li>
         <li v-if="convenience_fee_config && convenience_fee_config.is_convenience_fee_applied">
           {{convenience_fee_config && convenience_fee_config.convenience_fee_name ? convenience_fee_config.convenience_fee_name : 'Convenience Fee'}}
          <span class="fblue">
              {{ (convenience_fee_config.convenience_fee === 0) ? (currencySymbol + ' 0') : (currencySymbol + ' ' + (convenience_fee_config.convenience_fee).toFixed(2)) }}
            </span>
            <span @click="toggleConveniencePopup" class="float-none p-0 fa fa-info-circle fblue pointer"></span>
        </li>
        <!-- TODO: remove this if unnecessary else update if a backend change is needed -->
        <!--<li v-if='(_cart.payment_method_discount > 0)&&($route.path == "/checkout") '>-->
        <!--Additional Discounts-->
        <!--<span class="fred">-->
        <!-- - ₹ {{_cart.payment_method_discount}}-->
        <!--</span>-->
        <!--</li>-->
        <li v-if="cartwidgets.length > 0" v-for="item in otherCartWidgets">
          {{item.name}}
          <span>
            {{ currencySymbol }} {{(Number(item.value)).toFixed(2)}}
          </span>
        </li>
        <li v-if="bannerPlaceHolderForBillingCampaign && billingDonationCartWidgets && billingDonationCartWidgets.length" v-for="item in billingDonationCartWidgets">
          <span class="float-none m-0">{{bannerPlaceHolderForBillingCampaign.tag_text}} 
            <span v-if="bannerPlaceHolderForBillingCampaign && bannerPlaceHolderForBillingCampaign.description && bannerPlaceHolderForBillingCampaign.description.length" @click="toggleCampaignPopup" class="float-none p-0 fa fa-info-circle fblue pointer"></span>
             | <span @click="removeBillingCampaignDonation" class="float-none error p-0 pointer">Remove</span></span>
          <span>
            {{ currencySymbol }} {{(Number(item.value)).toFixed(2)}}
          </span>
        </li>
        <li v-if="bannerPlaceHolderForBillingCampaign && isBillingDonationApplicable">
          <span class="float-none m-0">{{bannerPlaceHolderForBillingCampaign.tag_text}} 
            <span v-if="bannerPlaceHolderForBillingCampaign && bannerPlaceHolderForBillingCampaign.description && bannerPlaceHolderForBillingCampaign.description.length" @click="toggleCampaignPopup" class="float-none p-0 fa fa-info-circle fblue pointer"></span>
             | <span @click="donateBillingCampaignDonation" class="float-none error p-0 pointer">Donate {{ currencySymbol }}{{billingDonationActualWidgets && billingDonationActualWidgets[0] && billingDonationActualWidgets[0].value}}</span></span>
          <span>
            {{ currencySymbol }} {{(Number(0)).toFixed(2)}}
          </span>
        </li>
        <li v-if="c.app_discount">
          App Discount
          <span class="fred">
             {{ currencySymbol }} {{ (c.app_discount).toFixed(2) }}
          </span>
        </li>
        <li class="fblue" v-if="c.gift_voucher_value">
          Gift Voucher
          <span class="fbold">
             {{ currencySymbol }} {{ c.gift_voucher_value.toFixed(2) }}
          </span>
        </li>
        <li class="fblue" v-if="c.used_tss_money">
          TSS Money Used
          <span class="fbold">
             {{ currencySymbol }} {{ (c.used_tss_money).toFixed(2) }}
          </span>
        </li>
        <li class="fbold">
          Total Amount <span v-if="bannerPlaceHolderForNewGstCartUi" class='fregular float-none gst-inclusive'>(Incl.of all taxes)</span>
           <span>
            <slot v-if="payMethod && payMethod === 'cod' && c.cod_charges">
              {{ currencySymbol }} {{ (c.total + c.cod_charges).toFixed(2) }}
            </slot>
            <slot v-else>
              {{ currencySymbol }} {{ (c.total).toFixed(2) }}
            </slot>
      </span>
      <div v-if="showCustomDutiesLabel" class="custom-duties-header"> {{ showCustomDutiesLabel.description }}</div>
        </li>
        <!-- <li class="fbold fblue" v-if="c.total_savings > 0 && !isExclusive">
          Total Savings
          <span>
        ₹ {{ parseInt(c.total_savings)}}
      </span>
        </li> -->
      </ul>
    </div>
    <popup-modal :title="`About ${bannerPlaceHolderForBillingCampaign && bannerPlaceHolderForBillingCampaign.tag_text}`" v-if='isCampaignPopup' :toggleModal="toggleCampaignPopup">
      <p>
        {{bannerPlaceHolderForBillingCampaign && bannerPlaceHolderForBillingCampaign.description}}
      </p>
    </popup-modal>
     <popup-modal :title="`About ${convenience_fee_config && convenience_fee_config.convenience_fee_name}`" v-if='conveniencePopup' :toggleModal="toggleConveniencePopup">
      <p>
        {{convenience_fee_config && convenience_fee_config.convenience_fee_message}}
      </p>
    </popup-modal>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import popupModal from './popupModal.vue'
  import moment from 'moment/src/moment'
  import Vue from 'vue'
  export default {
    data () {
      return {
        isCampaignPopup: false,
        conveniencePopup: false
      }
    },
    components: {
      popupModal
    },
    props: {
      payMethod: String
    },
    computed: {
      ...mapGetters({
        cartwidgets: 'cartwidgets',
        cartWidgets: 'cartWidgets',
        c: 'calculations',
        isExclusive: 'isExclusive',
        memberSavingsTxt: 'memberSavingsTxt',
        bannerPlcaeHolderData: 'bannerPlcaeHolderData',
        isBillingDonationApplicable: 'isBillingDonationApplicable',
        currencySymbol: 'currencySymbol',
        isSelectedCountryIndia: 'isSelectedCountryIndia',
        globalBannerPlaceholder: 'globalBannerPlaceholder',
        convenience_fee_config: 'convenience_fee_config'
      }),
      showPriceExclusiveOnCart () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_INC_OF_TEX_TEXT_CART_WEB')
      },
      showMrpOnCartGlobal () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GLOBAL_MRP_TEXT_CART_WEB')
      },
      showCustomDutiesLabel () {
        return this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData =>
        bannerData.is_active === true && bannerData.config_key === 'SHOW_CUSTOM_DUTIES_WEB')
      },
      getBillingDiscount () {
        return this.c.total_savings - this.c.coupon_discount
      },
      bannerPlaceHolderForNewGstCartUi: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'NEW_CART_BILLING_UI_WEB'.toLowerCase())
      },
      bannerPlaceHolderConvenienceCharges: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SHOW_CONVENIENCE_FEE_CART_WEB'.toLowerCase())
      },
      bannerPlaceHolderForCouponDiscount: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'COUPON_DISCOUNT_BILLING_UI_WEB'.toLowerCase())
      },
      bannerPlaceHolderForBillingCampaign: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'BILLING_DONATION_CAMPAIGN'.toLowerCase())
      },
      otherCartWidgets () {
        return this.cartwidgets && this.cartwidgets.length && this.cartwidgets.filter(itm => itm.name !== 'BILLING_DONATION_CAMPAIGN')
      },
      billingDonationCartWidgets () {
        return this.cartwidgets && this.cartwidgets.length && this.cartwidgets.filter(itm => itm.name === 'BILLING_DONATION_CAMPAIGN')
      },
      billingDonationActualWidgets () {
        return this.cartWidgets && this.cartWidgets.length && this.cartWidgets.filter(itm => itm.name === 'BILLING_DONATION_CAMPAIGN')
      },
      isDonationCampaignInTimeShedule () {
        let now = new Date()
        return moment(now) >= moment(this.bannerPlaceHolderForBillingCampaign.start_date_time) && moment(now) < moment(this.bannerPlaceHolderForBillingCampaign.end_date_time)
      }
    },
    methods: {
      toggleCampaignPopup () {
        this.isCampaignPopup = !this.isCampaignPopup
      },
      toggleConveniencePopup () {
        this.conveniencePopup = !this.conveniencePopup
      },
      removeBillingCampaignDonation () {
        this.$store.dispatch('UPDATE_CART', {operation: 'delete', type: 'widgets', data: this.billingDonationCartWidgets[0], hideToaster: true}).then((res) => {
          if (this.bannerPlaceHolderForBillingCampaign && this.bannerPlaceHolderForBillingCampaign.is_timer) {
            if (this.isDonationCampaignInTimeShedule) {
              this.$store.commit('SET_BILLING_DONATION_CAMPAIGN', true)
              Vue.toasted.show('Donation Amount removed', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
            } else {
              this.$store.commit('SET_BILLING_DONATION_CAMPAIGN', false)
            }
          }
        })
      },
      donateBillingCampaignDonation () {
        if (this.bannerPlaceHolderForBillingCampaign && this.bannerPlaceHolderForBillingCampaign.is_timer) {
          if (this.isDonationCampaignInTimeShedule && this.billingDonationActualWidgets) {
            this.$store.dispatch('UPDATE_CART', {operation: 'set', type: 'widgets', data: this.billingDonationActualWidgets[0]}).then(() => {
              this.$store.commit('SET_BILLING_DONATION_CAMPAIGN', false)
              Vue.toasted.show('Donation Amount Added', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
            })
          } else {
            this.$store.commit('SET_BILLING_DONATION_CAMPAIGN', false)
            Vue.toasted.show('Donation Campaign Expired', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
          }
        }
      }
    }
  }
</script>
<style lang="css" scoped>
  .gst-inclusive {
    font-size: 13px;
    color: #979a9f;
  }
  .custom-duties-header {
    font-weight: 400;
    font-size: 13px;
    color: #e66a51;
    margin-top: 5px;
  }
  .revamp {
    text-decoration: line-through;
    color: #B5B5B5;
  }
  @media (max-width: 768px) {
    .sidebox {
      margin-bottom: 0;
    }
  }
  .mrp-text {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// billingDetails.vue?b336994c